import Backbone from 'backbone'
import $ from 'jquery'
import template from './documents-overview.hbs'
import Related from 'scoreboard/related-items/related-items-list'
import DocumentsDisplayHeader from './documents-display-header'
import formatValue from 'scoreboard/components/format-value'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import tabs from 'scoreboard/components/view-edit-tabs.hbs'
import SendToOptions from 'scoreboard/components/send-to-options'
import fileInfo from 'scoreboard/components/files/file-info'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import FileDropOverlay from 'scoreboard/components/files/file-drop-overlay'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'
import globals from 'scoreboard/components/globals'
import appDisplay from 'scoreboard/components/app-display'
import documentsImagePreviewDialog from './documents-image-preview-dialog.hbs'
import UploadForm from 'scoreboard/components/files/upload-form'
import config from 'scoreboard/components/config'
import fileDrop from 'scoreboard/components/files/file-drop.hbs'
import UsedInList from 'scoreboard/documents/used-in-list'
import importStatus from 'scoreboard/admin/imports/import-status'
import constants from 'scoreboard/components/constants'
import RevisionWizard from './revision-wizard'
import permissions from 'scoreboard/components/permissions'
import { NewColumnNameChooserWizard } from 'scoreboard/imports/new-column-name-chooser-wizard'

var ImagePreviewDialog = Backbone.View.extend({
	className: 'image-preview-dialog',

	initialize: function({ imageUrl } = {}) {
		this.imageUrl = imageUrl
	},

	render: function() {
		this.$el.empty().append(documentsImagePreviewDialog({ imageUrl: this.imageUrl }))
		return this
	}
})

var DocumentsOverview = Backbone.View.extend({

	// this.model is a Document

	className: 'display-layout table-hack documents documents-overview',

	events: {
		'click .download': 'download',
		'click .download-revision': 'downloadRevision',
		'dragenter': 'onDragEnter',
		'click .image-preview': 'showImagePreview',
		'click .file-drop': 'onClickFileDrop',
		'click .list-item-actions .edit-import': 'onEditImport',
		'click .list-item-actions .run-import': 'onRunImport',
		'click .list-item-actions .delete-import': 'onDeleteImport'
	},

	initialize: function() {
		this.listenTo(Backbone, 'edit:domain-object', this.editDomainObject)
		importStatus.subscribe()
		this.listenTo(importStatus, 'change', ({id, lastImportStatus}) => {
			this.updateImportStatus(id, lastImportStatus)
		})
		this.listenTo(this, 'done', () => {
			// after a revision is uploaded, update any import statuses
			// since renderBody() will still reflect the original statuses
			// from the context and may have overwritten updates from the
			// listening to importStatus changes
			_.each(this.context().imports, imp => {
				let status = importStatus.get(imp.id)
				let lastImportStatus = _.get(status, 'lastImportStatus')
				this.updateImportStatus(imp.id, lastImportStatus)
			})
		})
	},

	render: function () {
		this.removeChildren()
		this.header = new DocumentsDisplayHeader({
			model: this.model,
			subsection: 'overview',
			tabs: tabs({
				id: this.model.id, section: 'files',
				overviewTabCode: 'common.overview',
				hideAlerts: true
			}),
			sendToOptions: SendToOptions.default({section: 'files'})
		})
		this.related = new Related({ model: this.model })

		this.$el.empty().append(this.header.el)
		this.header.render()
		this.renderBody()
		this.secure()
		return this
	},

	onDragEnter: function(e) {
		this.fileDropOverlay.show()
	},

	onClickFileDrop: function() {
		this.showUploadForm()
	},

	showUploadForm: function(e) {
		// #29617 if a revision is being uploaded for a file in use by imports,
		// provide a 2-step wizard
		let imports = this.context().imports
		if (!_.isNil(imports) && imports.length > 0) {
			this.revisionWizard = new RevisionWizard(this.uploadRevisionOptions(e))
			this.revisionWizard.start()
			this.revisionWizard.on('done', document => {
				this.renderBody()
				this.trigger('done', document)
			})
		} else {
			_.invoke(this.uploadForm, 'remove')
			const options = {
				url: '/api/files/revision/columns',
				params: {
					documentId: this.model.id
				},
				doneKey: 'common.save'
			}
			this.newColumnNameChooserWizard = new NewColumnNameChooserWizard(
				UploadForm, _.extend(options, this.uploadRevisionOptions(e)))
			this.newColumnNameChooserWizard.start()
			this.newColumnNameChooserWizard.on('done', document => {
				this.renderBody()
				this.trigger('done', document)
			})
		}
	},

	/**
	 * Updates import items to reflect the latest import status
	 */
	updateImportStatus: function (id, lastImportStatus) {
		let statusClasses = 'failed partial-success success cancelled interrupted'
		if (lastImportStatus && lastImportStatus !== 'running') {
			this.$(`[data-id=${id}]`)
				.removeClass(statusClasses)
				.addClass(lastImportStatus)
		}
		// if the status is undefined (due to editing the import), just clear
		// the existing status
		if (_.isNil(lastImportStatus)) {
			this.$(`[data-id=${id}]`).removeClass(statusClasses)
		}
	},

	/**
	 * Builds options for UploadForm when uploading a revision
	 */
	uploadRevisionOptions: function(e) {
		// basic options
		let options = {
			model: this.model,
			files: _.result(e, 'originalEvent.dataTransfer.files'),
			accept:  config.allowedFileTypes,
			instructions: 'documents.upload.drop.revision',
			maintainSelection: true
		}
		// extra options if file is in use by dashboards or imports
		options = _.extend(options, this.extendedUploadRevisionOptions(e))
		return options
	},

	/**
	 * Builds extra options for the upload form if uploading a revision when
	 * dashboards or imports are using the file
	 */
	extendedUploadRevisionOptions: function(e) {
		let accept = config.allowedFileTypes
		let message, extensionMessage
		let extensionKey = 'documents.revision.invalidExtension'
		let dashboards = this.context().dashboards
		if (!_.isNil(dashboards) && dashboards.length > 0) {
			accept = ['image']
			let messageKey = 'documents.imageUsedByDashboards'
			// use a different message key if strategy maps are enabled
			let suffix = config.displayStrategyMaps ? 'strategyMaps' : null
			message = this.buildCountMessage(messageKey, suffix, dashboards.length)
			let key = extensionKey + '.dashboards'
			extensionMessage =
				this.buildCountMessage(key, suffix, dashboards.length)
		}
		let imports = this.context().imports
		if (!_.isNil(imports) && imports.length > 0) {
			accept = ['spreadsheetWithoutNumbers']
			extensionMessage =
				this.buildCountMessage(extensionKey, 'imports', imports.length)
		}
		// if this was revision dropped via the file-drop-overlay, we need to
		// pass that along so we know if we should display the extensionMessage
		// when the upload form is displayed
		let revisionDrop = !_.isNil(e) && !_.isNil(this.context().revisions)
		return {
			message,
			extensionMessage,
			accept,
			revisionDrop
		}
	},

	buildCountMessage: function(key, suffix, count) {
		if (suffix) {
			key = key + '.' + suffix
		}
		return i18n.countMessage(key, count)
	},

	// renders most of this view, but not the header
	renderBody: function() {
		let context = this.context()
		// clear out everything other than the header
		this.header.$el.nextAll().remove()
		this.$el.append(template(context))
		this.imagePreview = this.$('.image-preview') // Cache for resize event
		this.imagePreviewSize(context)
		this.on('resize', () => this.imagePreviewSize(context))
		this.$('.related').append(this.related.el)
		this.related.render()
		this.renderUsedInPanels(context)
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		this.renderFileDrop()
	},

	renderFileDrop: function() {
		this.$('.file-drop').append(fileDrop({
			noDropMessage: window.FormData ? null :
				i18n.get('documents.upload.noDrop'),
			dropLabel: i18n.get('documents.upload.drop.revision.1'),
			dropSubLabel: i18n.get('documents.upload.drop.revision.2')
		}))
		this.fileDropOverlay = new FileDropOverlay({
			message: i18n.get('documents.upload.drop.revision.1')
		})
		this.$el.append(this.fileDropOverlay.el)
		this.fileDropOverlay.render()
		this.fileDropOverlay.on('drop', e => this.showUploadForm(e))
	},

	imagePreviewSize: function(context) {
		let maxHeight = 300
		if (context.width >= context.height) {
			// We need a fixed width set for loading the image, but we need to make
			// sure the image doesn't exceed the panel width. So take whichever value
			// is less between the image and the panel.
			let docInfoWidth =
				this.$('.document-info').width() - constants.STANDARD_MARGIN
			let width = Math.min(context.width, docInfoWidth)
			let imgRatio = context.height / context.width
			this.imagePreview
				.width(width)
				.height(width * imgRatio)
		} else if (context.height > maxHeight) {
			let imgRatio = context.width / context.height
			this.imagePreview
				.height(maxHeight)
				.width(maxHeight * imgRatio)
		} else {
			// If the image is neither wider than the panel, or taller than the
			// max-height, set the image to its exact measurement.
			this.imagePreview
				.height(context.height)
				.width(context.width)
		}
	},

	// #21209 If the file is an image and is used somewhere else (dashboard/strategy-map),
	// render a panel listing those other places
	renderUsedInPanels: function(context) {
		if (context.type === 'documents.fileType.image') {
			let items = {
				dashboards: [],
				strategyMaps: []
			}

			_.each(context.dashboards, item => {
				if (item.type == 'dashboard') {
					items.dashboards.push(item)
				} else if (item.type == 'strategy-map') {
					items.strategyMaps.push(item)
				}
			})

			var usedInList = function(type, el, title) {
				if (items[type].length > 0) {
					let list = new UsedInList({
						items: items[type],
						title
					})
					el.append(list.el).removeClass('is-not-displayed')
					list.render()
					return list
				}
			}

			this.dashboardsList = usedInList('dashboards', this.$('.dashboards'), i18n.get('dashboards.dashboards'))
			this.strategyMapsList = usedInList('strategyMaps', this.$('.strategy-maps'), i18n.get('strategyMaps.strategyMaps'))
		}
	},

	secure: function() {
		this.header.conditionallyHideEditTab(this.model.isEditable())
		// #32605 only show the file drop if the user has permission to modify documents
		if (!permissions.documents()) {
			this.$('.file-drop').addClass('is-not-displayed')
			this.fileDropOverlay.remove()
		}
	},

	context: function() {
		var context = _.assign({}, this.model.attributes)

		var revisions = this.model.get('revisions')
		if (!_.isEmpty(revisions)) {
			var lastRevision = revisions[revisions.length-1]
			var size = lastRevision.size
			if (size >= 1000000) {
				size = formatValue({ value: size/1000000, precision: 2 })
				size = i18n.get('common.size.mb', size)
			}
			else {
				size = formatValue({ value: size/1000, precision: 2 })
				size = i18n.get('common.size.kb', size)
			}
			context.size = size
			context.height = lastRevision.height
			context.width = lastRevision.width
			context.lastModified = lastRevision.lastModified
			let fileIcon = fileInfo.icon(lastRevision.label)
			_.each(context.imports, importData => {
				importData.ownersString = _(importData.owners).map('label').join(', ')
				importData.numMappingsString = i18n.countMessage('admin.import.mappings', importData.numMappings)
				importData.href = 'admin/imports/' + importData.id
			})
			_.each(context.datasets, dataset => {
				dataset.href = `datasets/${dataset.id}`
			})
			context.type = 'documents.fileType.' + fileInfo
				.type(lastRevision.label)
			context.extension = fileInfo.extension(lastRevision.label)
			context.icon = fileIcon
			context.isSpreadsheet = fileIcon == 'docs-spreadsheet'
			if (fileIcon == 'docs-image') {
				this.imageUrl = scoreboardUrl(`api/images/${lastRevision.id}/?database=${globals.databaseId}`)
				context.url = this.imageUrl
			}
			// There is no csv specific icon, use the spreadsheet icon instead
			if (fileIcon == 'docs-csv') {
				context.icon = 'docs-spreadsheet'
			}
		}

		return context
	},

	download: function(e) {
		this.model.download()
	},

	downloadRevision: function(e) {
		var revisionId = this.$(e.target).closest('[data-revision-id]').data('revision-id')
		this.model.downloadRevision(revisionId)
	},

	showImagePreview: function() {
		appDisplay.dialog(new ImagePreviewDialog({
			imageUrl: this.imageUrl
		}))
	},

	editDomainObject: function(model) {
		if (this.model.id == model.id) {
			this.model = model
		}
		this.render()
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		this.removeChildren()
		importStatus.unsubscribe()
	},

	removeChildren: function() {
		_.invokeMap([this.header, this.related, this.dashboardsList,
			this.strategyMapsList, this.uploadForm, this.covertButtonTooltips,
			this.revisionWizard], 'remove')
	}

})

DocumentsOverview.loadOptions = () => ({
	// #54197 provide loadOptions so both datasets and imports display
	// when navigating from another section
	datasets: true,
	imports: true
})

export default DocumentsOverview

DocumentsOverview.__filename__ = 'documents/documents-overview.js'
